import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { powerModel } from '../model/index';

@Injectable()
export class PowerService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private powerUrl = 'api/power';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getPowerList(query: any): Promise<powerModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.powerUrl}/getPowerList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deletePower(power_id: any): Promise<powerModel> {
        const url = `${this.powerUrl}/deletePower`;
        return this.http
            .post(url, $.param({ power_id: power_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as powerModel)
            .catch(this.handleError);
    }

    addUpdatePower(powerData: any): Promise<powerModel> {

        const url = `${this.powerUrl}/addUpdatePower`;

        return this.http
            .post(url, $.param(powerData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as powerModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/power.service.ts